
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/fraud-prevention/issue-transaction",
      function () {
        return require("private-next-pages/help/fraud-prevention/issue-transaction.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/fraud-prevention/issue-transaction"])
      });
    }
  